var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProgressCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "512.000000pt",
    height: "512.000000pt",
    viewBox: "0 0 512.000000 512.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,512.000000) scale(0.100000,-0.100000)",
    fill: "#4B9BF5",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2776 4682 c-3 -3 -6 -99 -6 -214 0 -158 3 -209 13 -212 6 -2 55 -11 107 -20 52 -10 148 -35 214 -57 586 -195 1014 -683 1138 -1300 33 -165 33 -463 0 -627 -127 -630 -564 -1127 -1158 -1315 -61 -19 -156 -43 -212 -53 l-102 -17 0 -214 0 -213 48 6 c379 47 777 213 1076 452 440 351 728 879 787 1441 16 155 7 443 -20 591 -129 735 -624 1343 -1319 1619 -118 47 -330 104 -447 121 -44 6 -88 13 -97 15 -9 1 -19 0 -22 -3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2200 4660 c-216 -37 -377 -89 -575 -185 -123 -59 -293 -164 -379 -234 l-39 -31 155 -156 154 -156 84 61 c168 121 418 229 640 275 l105 22 3 212 2 212 -22 -1 c-13 0 -70 -9 -128 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M859 3847 c-222 -296 -376 -675 -415 -1019 l-7 -58 212 0 c161 0 213 3 215 13 2 6 11 53 20 102 41 222 170 515 299 678 l30 39 -154 153 -154 154 -46 -62z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2780 2785 l-515 -515 -225 225 -225 225 -115 -115 -115 -115 335 -335 c184 -184 339 -335 345 -335 6 0 294 283 640 630 l630 630 -110 110 c-60 60 -114 110 -120 110 -5 0 -242 -232 -525 -515z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M445 2298 c46 -362 204 -747 423 -1031 l44 -59 40 39 c22 21 89 91 150 155 l109 117 -38 53 c-137 187 -239 422 -287 663 l-22 110 -213 3 -213 2 7 -52z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1362 1054 l-152 -146 48 -38 c279 -222 691 -396 1035 -436 l57 -7 0 212 c0 161 -3 212 -12 215 -7 2 -55 11 -106 20 -198 36 -424 128 -602 247 -52 35 -100 67 -106 71 -6 4 -76 -55 -162 -138z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProgressCheck);
export default __webpack_public_path__ + "static/media/progress_check.fe2b0ff59997dbfa54d2e799e361e9f1.svg";
export { ForwardRef as ReactComponent };